import { ComponentBase } from "../core/ComponentBase.js";

export class TaskWorkspaceManager extends ComponentBase {
    static styles = `
        .task-workspace-manager {
            height: 100%;
            min-height: 0;
            overflow: hidden;
        }
        .task-workspace-error {
            margin: 1rem;
        }
    `;

    constructor(config) {
        super(config);
        this.delegate = null;
        this.delegateType = null;
        this._boundHandleProjectChange = this.handleProjectChange.bind(this);
        this.applyStyles();
    }

    async initialize() {
        this.appClient.events.local.on('projectSelected', this._boundHandleProjectChange);
        const selectedProject = this.appClient.getSharedData('selectedProject');
        if (selectedProject) {
            const contextId = selectedProject._id;
            const userId = this.appClient.getSharedData('userId');
            this.config = {
                ...this.config,
                contextId,
                contextType: contextId ? 'project' : 'user',
                ownerId: userId
            };
        }
        await super.initialize();
    }

    async handleProjectChange({ projectData }) {
        const contextId = projectData ? projectData._id : null;
        const userId = this.appClient.getSharedData('userId');
        await this.updateContext({
            contextId,
            contextType: contextId ? 'project' : 'user',
            ownerId: userId
        });
        if (this.container) await this.render();
    }

    resolveDelegateType() {
        if (this.config.component) return this.config.component;
        if (this.config.provider === 'mageledgerWork') return 'MageMapTasks';
        return 'task-workspace/TaskManager';
    }

    resolveDelegateProps() {
        const {
            appClient,
            instanceId,
            component,
            provider,
            type,
            ...props
        } = this.config;

        return {
            provider,
            ...props,
            ...(this.config.props || {})
        };
    }

    async updateContext(context = {}) {
        this.config = { ...this.config, ...context };
        if (typeof this.delegate?.updateContext === 'function') {
            await this.delegate.updateContext(context);
        } else if (this.delegate?.taskSelector) {
            await this.delegate.taskSelector.updateContext(context);
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'task-workspace-manager';
        }

        this.container.innerHTML = '';
        const delegateType = this.resolveDelegateType();

        try {
            if (!this.delegate || this.delegateType !== delegateType) {
                if (this.delegate?.destroy) await this.delegate.destroy();
                this.delegateType = delegateType;
                this.delegate = await this.createManagedComponent(delegateType, null, {
                    instanceId: `${this.config.instanceId || 'task-workspace'}-${delegateType}`,
                    ...this.resolveDelegateProps()
                });
            }
            this.container.appendChild(await this.delegate.render());
        } catch (error) {
            this.log.error(`Failed to render task workspace delegate ${delegateType}:`, error);
            const safeDelegateType = String(delegateType).replace(/[&<>"']/g, char => ({
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            }[char]));
            this.container.innerHTML = `
                <div class="alert alert-danger task-workspace-error">
                    Failed to load task workspace component <code>${safeDelegateType}</code>.
                </div>
            `;
        }

        return this.container;
    }

    async destroy() {
        this.appClient.events.local.off('projectSelected', this._boundHandleProjectChange);
        if (this.delegate?.destroy) await this.delegate.destroy();
        await super.destroy();
    }
}
